import { ReactNode } from 'react';
import { useAction } from '../../context';
import { CustomViewPages } from './pages';
import { CustomViewRegister } from './registry';

type PropsInclude = {
  id: string;
  typeId?: string;
  templateId?: string;
  children?: ReactNode;
};

CustomViewRegister.register({
  id: 'include',
  function: function IncludeComponent({
    children,
    id,
    typeId,
    templateId,
  }: PropsInclude) {
    const getInclude = useAction('getInclude');
    const parentInfo = useAction('getCustomViewInfo')();
    return (
      getInclude(
        id,
        typeId || parentInfo.typeId || '',
        templateId || parentInfo.templateId || '',
      ) ||
      (CustomViewPages.get(id) || (() => <>{children}</>))() || <>{children}</>
    );
  },
});
